// Pathify
import { make } from 'vuex-pathify'
import axios from 'axios'
import auth from './authentification'

const state = {
  affectedAssetList: [],
  roadList: [],
  /*bridgeList: [],
  schoolList: [],
  hospitalList: [],
  publicBuildingList: [],
  irrigationList: [],
  equipmentList: []*/
}

const mutations = {
  setAffectedAssetList(state, payload) {
   state.affectedAssetList = payload;
  },
  setRoadList(state, payload) {
    state.roadList = payload;
  },
  /*setBridgeList(state, payload) {
    state.bridgeList = payload;
  },
  setSchoolList(state, payload) {
    state.schoolList = payload;
  },
  setHospitalList(state, payload) {
    state.hospitalList = payload;
  },
  setPublicBuildingList(state, payload) {
    state.publicBuildingList = payload;
  },
  setIrrigationList(state, payload) {
    state.irrigationList = payload;
  },
  setEquipmentList(state, payload) {
    state.equipmentList = payload;
  }*/
}

const actions = {
  getAffectedAssetList: ({ state, commit }, payload) => {
    try{
        axios.post(`/api/affected_assets_disaster`,payload).then(response => {
        commit('setAffectedAssetList', response.data);
      });
    } catch(error){
      commit('setAffectedAssetList', []);
    }
  },
  //NOT USED FOR THE MOMENT
  getRoadList: ({ state, commit }) => {
    try{
      axios.get(`/api/roads`).then(response => {
        commit('setRoadList', response.data);
      });
    } catch(error){
      commit('setRoadList', []);
    }
  },

  //TODO IF NEEDED
  /*getBridgeList: ({ state, commit }) => {
    try{
      axios.get(`/api/bridges`).then(response => {

        commit('setBridgeList', response.data);
      });
    } catch(error){
      commit('setBridgeList', []);
    }
  },
  getSchoolList: ({ state, commit }) => {
    try{
      axios.get(`/api/schools`).then(response => {

        commit('setSchoolList', response.data);
      });
    } catch(error){
      commit('setSchoolList', []);
    }
  },
  getHospitalList: ({ state, commit }) => {
    try{
      axios.get(`/api/hospitals`).then(response => {

        commit('setHospitalList', response.data);
      });
    } catch(error){
      commit('setHospitalList', []);
    }
  },
  getPublicBuildingList: ({ state, commit }) => {
    try{
      axios.get(`/api/public_buildings`).then(response => {

        commit('setPublicBuildingList', response.data);
      });
    } catch(error){
      commit('setPublicBuildingList', []);
    }
  },
  getIrrigationList: ({ state, commit }) => {
    try{
      axios.get(`/api/irrigations`).then(response => {

        commit('setIrrigationList', response.data);
      });
    } catch(error){
      commit('setIrrigationList', []);
    }
  },
  getEquipmentList: ({ state, commit }) => {
    try{
      axios.get(`/api/equipments`).then(response => {

        commit('setEquipmentList', response.data);
      });
    } catch(error){
      commit('setEquipmentList', []);
    }
  },*/


  addAffectedRoad: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/new_affected_road`,payload).then(response => {
        dispatch('getAffectedAssetList',{'asset_type_id': 1});
      });
    } catch(error){
      commit('setAffectedAssetList', []);
    }
  },
  addAffectedBridge: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;
      
      axios.post(`/api/new_affected_bridge`,payload).then(response => {
        dispatch('getAffectedAssetList',{'asset_type_id': 2});
      });
    } catch(error){
      commit('setAffectedAssetList', []);
    }
  },
  addAffectedSchool: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/new_affected_school`,payload).then(response => {
        dispatch('getAffectedAssetList',{'asset_type_id': 3});
      });
    } catch(error){
      commit('setAffectedAssetList', []);
    }
  },
  addAffectedHospital: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;
      
      axios.post(`/api/new_affected_hospital`,payload).then(response => {
        dispatch('getAffectedAssetList',{'asset_type_id': 4});
      });
    } catch(error){
      commit('setAffectedAssetList', []);
    }
  },
  addAffectedPublicBuilding: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/new_affected_public_building`,payload).then(response => {
        dispatch('getAffectedAssetList',{'asset_type_id': 5});
      });
    } catch(error){
      commit('setAffectedAssetList', []);
    }
  },
  addAffectedIrrigation: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/new_affected_irrigation`,payload).then(response => {
        dispatch('getAffectedAssetList',{'asset_type_id': 6});
      });
    } catch(error){
      commit('setAffectedAssetList', []);
    }
  },
  addAffectedEquipment: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;
      
      axios.post(`/api/new_affected_equipment`,payload).then(response => {
        dispatch('getAffectedAssetList',{'asset_type_id': 7});
      });
    } catch(error){
      commit('setAffectedAssetList', []);
    }
  },



  /*addRoad: ({ state, commit, dispatch }, payload) => {
    try{
      axios.post(`/api/new_affected_road`,payload).then(response => {
        dispatch('getRoadList');
      });
    } catch(error){
      commit('setRoadList', []);
    }
  },*/
  /*updateRoad: ({ state, commit }, payload) => {
    try{
      axios.post(`/api/roads`,payload).then(response => {
        commit('setRoadList', response.data);
      });
    } catch(error){
      commit('setRoadList', []);
    }
  },
  deleteRoad: ({ state, commit, dispatch }, payload) => {
    try{
      axios.post(`/api/delete_road`,{id: payload}).then(response => {
        dispatch('getRoadList');
      });
    } catch(error){
      commit('setRoadList', []);
    }
  }*/

}

const getters = {
  roadList: state => {
    return state.roadList
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
